import React from "react";
import "./Pricing.css";

function Pricing() {
  return <div className="pricing">Pricing</div>;
}

export default Pricing;
